import moment from 'moment/moment';

export const getDiffInMinutes = (firstDate: string | undefined, secondDate: string | undefined) => {
  if (firstDate === undefined || secondDate === undefined) return;
  return Math.abs(moment(firstDate, 'DD.MM.YYYY, HH:mm').diff(moment(secondDate, 'DD.MM.YYYY, HH:mm'), 'minutes'));
};

export const getDiffInHours = (firstDate: string | undefined, secondDate: string | undefined) => {
  if (firstDate === undefined || secondDate === undefined) return;

  const duration = moment.duration(moment(firstDate).diff(moment(secondDate)));
  const hours = duration.asHours();
  return typeof hours === 'number' ? Math.abs(hours) : null;
};
